import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=5f075a74&scoped=true"
import script from "./Option.vue?vue&type=script&lang=js"
export * from "./Option.vue?vue&type=script&lang=js"
import style0 from "./Option.vue?vue&type=style&index=0&id=5f075a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f075a74",
  null
  
)

export default component.exports